module.exports = __webpack_public_path__ + "static/media/yellow-star.5782f45a.svg";